<template>
  <!-- Error boundary catches config validation errors and shows user-friendly message -->
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    >
    </FileConverter>
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

const converterConfig = parseAndValidateConverterConfig('ttf-to-woff-converter', 'TTF → WOFF');

function handleBatchCreated(batchId: string) {
  console.log('[TTF-to-WOFF Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[TTF-to-WOFF Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[TTF-to-WOFF Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[TTF-to-WOFF Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[TTF-to-WOFF Converter] Credits updated:', credits);
}
</script>
